import FileboxContainer from '@/containers/filebox/FileboxContainer';

export default [
  {
    path: '/filebox',
    name: 'Filebox',
    meta: { requiresAuth: true, action: 'view', subject: 'filebox' },
    component: FileboxContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/filebox.js